import { ArrowUpRight, Phone } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { CONTACT } from "../../lib/data";
import { goEnquire } from "../../lib/scroll";
import { Reveal } from "./Reveal";

export const CTABanner = ({ title = "Talk to a Finance Expert", text = "Share your requirement and let our advisory team structure the right financing approach for you." }) => {
  const navigate = useNavigate();
  return (
    <section className="relative overflow-hidden bg-navy-deep py-20 md:py-24" data-testid="cta-banner">
      <div className="absolute inset-0">
        <img src="/assets/cta-luxury.jpeg" alt="" aria-hidden="true" loading="lazy" className="h-full w-full object-cover object-center opacity-30" />
        <div className="absolute inset-0 bg-gradient-to-b from-navy-deep/80 via-navy-deep/70 to-navy-deep/90" />
      </div>
      <div className="pointer-events-none absolute left-1/2 top-1/2 h-[300px] w-[600px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-gold/15 blur-[130px]" />
      <Reveal className="relative mx-auto flex max-w-4xl flex-col items-center px-5 text-center">
        <h2 className="font-heading text-3xl font-bold tracking-tight text-white md:text-5xl">{title}</h2>
        <p className="mt-4 max-w-xl text-base text-white/70 md:text-lg">{text}</p>
        <div className="mt-8 flex flex-wrap justify-center gap-4">
          <button
            onClick={() => goEnquire(navigate)}
            data-testid="cta-enquire-btn"
            className="group flex items-center gap-2 rounded-full bg-gold px-7 py-4 text-sm font-bold text-inkx transition-transform duration-300 hover:scale-[1.04]"
          >
            Enquire Now
            <ArrowUpRight size={16} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </button>
          <a
            href={CONTACT.phoneHref}
            data-testid="cta-call-btn"
            className="flex items-center gap-2 rounded-full border border-white/30 px-7 py-4 text-sm font-semibold text-white transition-colors duration-300 hover:border-orange hover:text-gold"
          >
            <Phone size={15} /> {CONTACT.phone}
          </a>
        </div>
      </Reveal>
    </section>
  );
};
